export default async function getOrderDetailDms(
  repository,
  params,
) {
  return repository.getOrderDetailDms(params);
}
